/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuFilterCategory_filters = ReadonlyArray<{
    readonly name: string | null;
    readonly values: ReadonlyArray<{
        readonly count: number | null;
        readonly displayName: string | null;
        readonly linkReference: string | null;
        readonly linkable: boolean | null;
    } | null> | null;
    readonly " $refType": "SbRespRefineMenuFilterCategory_filters";
}>;
export type SbRespRefineMenuFilterCategory_filters$data = SbRespRefineMenuFilterCategory_filters;
export type SbRespRefineMenuFilterCategory_filters$key = ReadonlyArray<{
    readonly " $data"?: SbRespRefineMenuFilterCategory_filters$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuFilterCategory_filters">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SbRespRefineMenuFilterCategory_filters",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseFilterValue",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "linkReference",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "linkable",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SearchBrowseFilter",
  "abstractKey": null
};
(node as any).hash = 'e9becde0671167fac5f743f86fecec85';
export default node;
